import { useState, useRef, useEffect } from 'react';
import { Modal, Box, TextField, Button, Typography, Avatar, FormControlLabel, Switch } from '@mui/material';
import { addProduct, updateProduct, uploadImage } from '../api/github';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export default function AddProductModal({ open, onClose, product }) {
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [stock, setStock] = useState('');
  const [isSouvenir, setIsSouvenir] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const fileInputRef = useRef(null);

  const [errors, setErrors] = useState({
    name: false,
    price: false,
    stock: false
  });

  const validateForm = () => {
    const newErrors = {
      name: !name.trim(),
      price: !price || isNaN(price) || Number(price) <= 0,
      stock: !stock || isNaN(stock) || Number(stock) < 0
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some(error => error);
  };

  useEffect(() => {
    if (product) {
      setName(product.name || '');
      setPrice(product.price || '');
      setStock(product.stock || '');
      setIsSouvenir(product.isSouvenir || false);
      setPreviewUrl(product.image || '');
    } else {
      setName('');
      setPrice('');
      setStock('');
      setIsSouvenir(false);
      setPreviewUrl('');
      setImageFile(null);
    }
  }, [product, open]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleImageUpload = async (file) => {
    if (!file) return previewUrl;
    
    if (file.size > 5 * 1024 * 1024) {
      alert('Расим хажми 5MB дан кам бўлиши керак');
      return previewUrl;
    }

    try {
      const url = await uploadImage(file);
      return url;
    } catch (error) {
      alert('Расмни юклашда хатолик юз берди');
      return previewUrl;
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const imageUrl = imageFile ? await handleImageUpload(imageFile) : previewUrl;

    const productData = {
      name,
      price: Number(price),
      stock: Number(stock),
      isSouvenir: Boolean(isSouvenir),
      image: imageUrl
    };

    try {
      if (product) {
        await updateProduct(product.id, productData);
      } else {
        await addProduct(productData);
      }
      onClose(true);
    } catch (error) {
      console.error('Махсулотни сақлашда хатолик:', error);
      alert('Махсулотни сақлашда хатолик юз берди');
    }
  };

  return (
    <Modal open={open} onClose={() => onClose(false)}>
      <Box sx={style}>
        <Typography variant="h6">{product ? 'Махсулотни таҳрирлаш' : 'Махсулот қўшиш'}</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2 }}>
          <Avatar
            src={previewUrl}
            sx={{ width: 100, height: 100, mb: 2 }}
            variant="rounded"
            alt="Махсулот расми"
          />
          <input
            accept="image/*"
            style={{ display: 'none' }}
            id="product-image-upload"
            type="file"
            onChange={handleFileChange}
            ref={fileInputRef}
          />
          <label htmlFor="product-image-upload">
            <Button variant="contained" component="span">
              Расмни танлаш
            </Button>
          </label>
        </Box>
        <TextField
          label="Номи"
          fullWidth
          margin="normal"
          value={name}
          error={errors.name}
          onChange={(e) => setName(e.target.value)}
          helperText={errors.name ? 'Ном киритиш шарт' : ''}
        />
        <TextField
          label="Нархи (СУМ)"
          type="number"
 localised defective
          fullWidth
          margin="normal"
          value={price}
          error={errors.price}
          onChange={(e) => setPrice(e.target.value)}
          helperText={errors.price ? 'Нарx тўғри киритинг' : ''}
        />
        <TextField
          label="Омбордаги миқдори"
          type="number"
          fullWidth
          margin="normal"
          value={stock}
          error={errors.stock}
          onChange={(e) => setStock(e.target.value)}
          helperText={errors.stock ? 'Миқдор тўри киритинг' : ''}
        />
        <FormControlLabel
          control={
            <Switch
              checked={isSouvenir}
              onChange={(e) => setIsSouvenir(e.target.checked)}
            />
          }
          label="Сувенир"
          sx={{ mt: 1 }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button onClick={() => onClose(false)}>Бекор қилиш</Button>
          <Button onClick={handleSubmit} variant="contained">
            Сақлаш
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}